/**
* Created For: 终端类型、是否覆盖、品种选择筛选  this.$emit("filterHandle",this.curParams)
* Author: chenLiYan.
* Date: 2018/12/1 0001 11:15.
*/
<template>
  <div class="page-wrap" v-if="isShow" @click.self="hide();$emit('cancel')">
    <transition name="page-move">
      <div class="filter-wrap" v-if="infoShow">
        <div class="check-group-box">
          <p class="title">终端类型</p>
          <div class="li-box float-box">
            <button v-for="(clientType,index) in clientTypes" type="button" :class="[curParams.clientType.includes(clientType.code) ? 'selected':'']" @click="typeClickHandle(clientType.code)" :key="index">{{ clientType.name }}</button>
          </div>
        </div>
        <div class="check-group-box">
          <p class="title">环境标签</p>
          <div class="li-box float-box">
            <button v-for="(environmentalType,index) in environmentalLabels" type="button" :class="[curParams.boundaryTag.includes(environmentalType.code) ? 'selected':'']" @click="environmentalTypeClickHandle(environmentalType.code)" :key="index">{{ environmentalType.name }}</button>
          </div>
        </div>
        <div class="check-group-box">
          <p class="title">是否覆盖</p>
          <div class="li-box flex-wrap">
            <button type="button" :class="[curParams.cover === '' ? 'selected':'']" @click="coverClickHandle()">全部</button>
            <button type="button" :class="[curParams.cover === true ? 'selected':'']" @click="coverClickHandle(true)">已覆盖</button>
            <button type="button" :class="[curParams.cover === false ? 'selected':'']" @click="coverClickHandle(false)">未覆盖</button>
          </div>
        </div>
        <div class="check-group-box">
          <p class="title">覆盖率统计月份</p>
          <div class="li-box flex-wrap">
            <label class="month-label" @click="monthSegmentPicker.show()">
              <span>{{ monthText.startMonth || '开始月份' }}</span>一<span>{{ monthText.endMonth || '结束月份' }}</span>
              <span class="sprite icon-triangle-left-bottom"></span>
            </label>
          </div>
        </div>
        <div class="check-group-box">
          <p class="title">其他筛选</p>
          <cube-checkbox v-model="curParams.isCoveredAbnormal" position="right" shape="square" >
            包含覆盖的非正常终端
          </cube-checkbox>
        </div>
        <div class="check-group-box hasList">
          <p class="title">品种选择</p>
          <!--需求变更：不显示品种搜索-->
          <div class="goods-search" v-if="false">
            <search-bar
              ref="keywordInput"
              :defaultVal="defaultGoodsInfo.keyword"
              @input="inputHandle">
            </search-bar>
          </div>
        </div>
        <ul class="goods-list">
          <li v-for="(item,index) in curGoodsList" :key="index" :class="['goods-li','flex-wrap', selectedGoodsInfo.id.indexOf(item.id) > -1 ? 'selected':'']" @click="selectGoods(item)">
            <span class="name">{{ item.name }}</span>
            <span class="sprite icon-check-right none"></span>
          </li>
        </ul>
        <!--iphone X小黑条占位-->
        <div class="home-indicator"></div>
        <!--底部按钮区域-->
        <div class="btn-box flex-wrap">
          <button type="button" class="cancel" @click="hide();$emit('cancel')">取消</button>
          <button type="button" class="sure" @click="sureHandle()">确认</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SearchBar from './_search_bar.vue'
import { asyncGetUserDrug } from '@/api/goods'
import { getClientType } from '../../api/clientSearch'
export default {
  name: 'ClientFilter',
  components: { SearchBar },
  props: {
    // 已选参数
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShow: false, // 遮盖层整个页面的显示
      infoShow: false, // 带动效的页面内容数据显示
      curParams: {
        clientType: '', // 客户类型
        cover: '', // 是否覆盖 true false
        drugName: '', // 药品名称
        spec: '', // 药品规格
        startTime: '',
        endTime: '',
        boundaryTag: '',
        isCoveredAbnormal: false,
        isDisplay: false
      },
      clientTypes: {
        10101: '单体',
        10102: '连锁门店',
        10103: '连锁总部',
        20101: '诊所'
      },
      environmentalLabels: [
        {
          code: 'business',
          name: '商圈边店'
        }, {
          code: 'hospital',
          name: '医院边店'
        },
        {
          code: 'o2o',
          name: 'O2O药店'
        }
      ],
      // 默认已选品种数据,只有按确定时，才
      defaultGoodsInfo: {
        id: '',
        keyword: '',
        list: []
      },
      // 当前已勾选商品数据
      selectedGoodsInfo: {
        id: [],
        keyword: '',
        list: []
      },
      curGoodsList: [], // 当前可供选择品种列表
      curKeyword: '', // 当前品种关键词
      allGoodsList: [], // 所有的可选商品列表
      // 覆盖率起始时间选择器
      monthSegmentPicker: null,
      monthSegmentData: [
        {
          is: 'cube-date-picker',
          title: '开始月份',
          value: new Date(this.$dayjs().subtract(1, 'month')),
          format: {
            year: 'YYYY年',
            month: 'MM月'
          },
          startColumn: 'year',
          columnCount: 2
        },
        {
          is: 'cube-date-picker',
          title: '结束月份',
          value: new Date(this.$dayjs().subtract(1, 'month')),
          format: {
            year: 'YYYY年',
            month: 'MM月'
          },
          startColumn: 'year',
          columnCount: 2
        }
      ],
      // 默认起始月份显示文字，当前月的上一个月
      monthText: {
        startMonth: '',
        endMonth: ''
      }
    }
  },
  computed: {
  },
  beforeMount () {
    this.clientTypeList()
    asyncGetUserDrug({ drugName: '' }).then(res => {
      if (res.code === 1) {
        this.allGoodsList = res.data.itemList || []
        this.defaultGoodsInfo.list = this.allGoodsList
      }
    })
    this.monthSegmentPicker = this.$createSegmentPicker({
      data: this.monthSegmentData,
      onSelect: (selectedDates, selectedVals, selectedTexts) => {
        this.monthText.startMonth = selectedTexts[0].join('')
        this.monthText.endMonth = selectedTexts[1].join('')
        this.curParams.startTime = this.$dayjs(selectedDates[0]).startOf('month').valueOf()
        this.curParams.endTime = this.$dayjs(selectedDates[1]).endOf('month').valueOf()
      },

      // eslint-disable-next-line no-unused-vars
      onNext: (i, selectedDate, selectedValue, selectedText) => {
        this.monthSegmentData[1].min = selectedDate
        if (i === 0) {
          this.monthSegmentPicker.$updateProps({
            data: this.monthSegmentData
          })
        }
      }
    })
  },
  methods: {
    show () {
      console.log('传给弹框的数据')
      console.log(this.params)
      this.curParams.clientType = this.params.clientType ? this.params.clientType.split(',') : []
      this.curParams.boundaryTag = this.params.boundaryTag ? this.params.boundaryTag.split(',') : []
      this.curParams.cover = (this.params.cover === true || this.params.cover === false) ? this.params.cover : ''
      this.curParams.drugName = this.params.drugName || ''
      this.curParams.spec = this.params.spec || ''
      this.curParams.startTime = this.params.startTime || ''
      this.curParams.endTime = this.params.endTime || ''
      // 重置时间
      this.monthSegmentData[0].value = new Date(this.curParams.startTime)
      this.monthSegmentData[1].value = new Date(this.curParams.endTime - 24 * 60 * 60)
      // 重置最小可选时间
      this.monthSegmentData[0].min = this.params.minMonthTime ? new Date(this.params.minMonthTime) : new Date(2018, 3, 1)
      this.monthSegmentData[1].min = this.params.minMonthTime ? new Date(this.params.minMonthTime) : new Date(2018, 3, 1)
      // 重置最大可选时间
      this.monthSegmentData[0].max = this.params.maxMonthTime ? new Date(this.$dayjs(this.params.maxMonthTime)) : new Date(this.$dayjs().subtract(1, 'month'))
      this.monthSegmentData[1].max = this.params.maxMonthTime ? new Date(this.$dayjs(this.params.maxMonthTime)) : new Date(this.$dayjs().subtract(1, 'month'))
      this.monthSegmentPicker.$updateProps({
        data: this.monthSegmentData
      })
      this.monthText.startMonth = this.$dayjs(this.curParams.startTime).format('YYYY年MM月')
      this.monthText.endMonth = this.$dayjs(this.curParams.endTime - 24 * 60 * 60).format('YYYY年MM月')

      if (!this.curParams.drugName && !this.curParams.spec) {
        // 需重置品种数据
        this.defaultGoodsInfo = {
          id: '',
          keyword: '',
          list: this.allGoodsList
        }
        this.selectedGoodsInfo = {
          id: [],
          keyword: '',
          list: this.allGoodsList
        }
        this.curGoodsList = this.allGoodsList
        this.curKeyword = ''
      } else {
        // 重置显示当前可选项
        this.curGoodsList = Object.assign({}, this.defaultGoodsInfo).list
      }
      this.isShow = true
      const _this = this
      setTimeout(function () {
        _this.infoShow = true
      }, 10)
    },
    hide () {
      this.infoShow = false
      this.isShow = false
    },
    clientTypeList () {
      const { entries } = Object
      const list = {}
      const listArr = []
      getClientType().then(
        (res) => {
          if (res.code === 1) {
            //  state.clientType = res.data;
            // eslint-disable-next-line no-unused-vars
            for (const [key, value] of entries(res.data.displayList)) {
              list[value['typeCode']] = value['typeName']
            }
            for (const [key, value] of entries(list)) {
              listArr.push({
                code: key,
                name: value
              })
            }
          }
        }
      )

      this.clientTypes = listArr
      this.$store.commit('clientTypesChange', list)
    },
    // 客户类型点击事件
    typeClickHandle (type) {
      if (this.curParams.clientType.includes(type)) {
        this.curParams.clientType.splice(this.curParams.clientType.indexOf(type), 1)
      } else {
        this.curParams.clientType.push(type)
      }
    },
    // 客户类型点击事件
    environmentalTypeClickHandle (type) {
      if (this.curParams.boundaryTag.includes(type)) {
        this.curParams.boundaryTag.splice(this.curParams.boundaryTag.indexOf(type), 1)
      } else {
        this.curParams.boundaryTag.push(type)
      }
    },
    // 是否覆盖点击事件
    coverClickHandle (type = '') {
      if (this.curParams.cover === type) {
        this.curParams.cover = ''
      } else {
        this.curParams.cover = type
      }
    },
    // 品种关键词输入事件
    inputHandle (keyword) {
      this.curKeyword = keyword
      asyncGetUserDrug(keyword).then(res => {
        if (res.code === 1) {
          this.curGoodsList = res.data.list
          if (this.curGoodsList.length === 0) {
            this.curGoodsList = this.allGoodsList
          }
        }
      })
    },
    // 选择品种事件
    selectGoods (item) {
      // if(item.id !== this.selectedGoodsInfo.id){
      //     this.selectedGoodsInfo.id = item.id;
      //     this.selectedGoodsInfo.keyword = this.curKeyword;
      //     this.selectedGoodsInfo.list = [...this.curGoodsList];
      //     this.curParams.drugName = item.id || '';
      //     this.curParams.spec = item.spec || '';
      // }else{
      //     this.selectedGoodsInfo.id = "";
      //     this.selectedGoodsInfo.keyword = "";
      //     this.selectedGoodsInfo.list = this.allGoodsList;
      //     this.curParams.drugName = "";
      //     this.curParams.spec = "";
      // }
      if (this.selectedGoodsInfo.id.indexOf(item.id) < 0) {
        this.selectedGoodsInfo.id.push(item.id)
        // this.selectedGoodsInfo.keyword = this.curKeyword;
        // this.selectedGoodsInfo.list = [...this.curGoodsList];
        this.curParams.drugName = this.selectedGoodsInfo.id.join(',')
        // this.curParams.spec = item.spec || '';
      } else {
        this.selectedGoodsInfo.id.splice(this.selectedGoodsInfo.id.findIndex((i) => i === item.id), 1)
        // this.selectedGoodsInfo.id = "";
        // this.selectedGoodsInfo.keyword = "";
        // this.selectedGoodsInfo.list = this.allGoodsList;
        this.curParams.drugName = this.selectedGoodsInfo.id.join(',')
        // this.curParams.spec = "";
      }
    },
    // 确认事件
    sureHandle () {
      this.defaultGoodsInfo = Object.assign({}, this.selectedGoodsInfo)
      this.curParams.clientType = this.curParams.clientType.join(',')
      this.curParams.boundaryTag = this.curParams.boundaryTag.join(',')
      this.hide()
      console.log('...............')
      console.log(this.curParams)
      this.$emit('filterHandle', this.curParams)
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl";
    .page-wrap{
        position fixed
        width 100%
        height 100%
        top: 0
        left 0
        background rgba(0,0,0,.6)
        z-index 91
    }
    .filter-wrap{
        width 610px
        height 100%
        padding-bottom 84px
        background #fff
        transition: transform .3s
        position absolute
        right 0
        top 0
        overflow auto
    }
    .check-group-box{
        margin 0 32px
        border-bottom 1px solid $border-color
        .title{
            font-weight bold
            line-height 64px
            padding-top 24px
            font-size $font-XXL
        }
        .li-box{
            &.flex-wrap{
                height 88px
                align-items center
            }
            button{
                padding 0 16px
                height 40px
                border 1px solid $color-font-lighter
                font-size $font-M
                color $color-font-lighter
                margin-right 30px
                border-radius 3px
                &.selected{
                    color $color-main
                    border-color $color-main
                }
                &:last-child{
                    margin-right 0
                }
            }
            &.float-box{
                width 578px
                padding-top 24px
                overflow hidden
                button{
                    float left
                    margin-bottom 24px
                }
            }
            .month-label{
                font-size $font-L
                .sprite{
                    transform translate(0,4px)
                    margin-left 13px
                }
            }
        }
        .goods-search{
            height 64px
            margin 24px 0
        }
        &.hasList{
            margin 0 0 8px
            padding 0 32px
            border-bottom none
            // box-shadow 0 5px 10px rgba(0,0,0,.1)
        }
    }
    .goods-list{
        max-height 704px
        padding-left 32px
        overflow auto
        .goods-li{
            height 88px
            padding-right 29px
            align-items center
            justify-content space-between
            border-bottom 1px solid $border-color
            word-break break-all
            .name{
                font-size $font-L
                line-height 36px
                max-width 480px
            }
            &.selected{
                .name{
                    color $color-main
                }
                .sprite{
                    display inline-block
                }
            }
        }
    }
    .btn-box{
        width 610px
        height 88px
        box-sizing content-box
        align-items center
        justify-content space-between
        position fixed
        right 0
        bottom 0
        background $color-white
        padding-bottom env(safe-area-inset-bottom)
        button{
            height 100%
            width 50%
            font-size $font-XXXL
            &.cancel{
                border-top 1px solid $border-color
                color $color-font
                background $color-white
            }
            &.sure{
                color $color-white
                background $color-main
            }
        }
    }

    // 过渡效果
    .page-move-enter, .page-move-leave-active
        transform: translate(100%, 0%)
    .page-move-enter-active, .page-move-leave-active
        transition: transform .6s
</style>
<style scoped>
    @-moz-document url-prefix(){
        .check-group-box .li-box button{
            line-height: 40px;
        }
    }

</style>
